// GET_GIFT
export const GET_GIFT = "GET_GIFT";

// CREATE_GIFT
export const CREATE_GIFT = "CREATE_GIFT";

// UPDATE_GIFT
export const UPDATE_GIFT = "UPDATE_GIFT";

// DELETE_GIFT
export const DELETE_GIFT = "DELETE_GIFT";
